import "./Account.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import MyChannels from "./MyChannels";
import InfoCards from "./InfoCards";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState, useEffect } from "react";
import { ProfileContext } from "../../context/profile";
import {
  accountUpgradeFetcher,
  campaignFetcher,
  categoryFetcher,
  channelFetcher,
  tagFetcher,
  videoFetcher,
} from "../../api/requests";
import AdminChannels from "./AdminChannels";
import { Spinner } from "react-bootstrap";
import { ChannelContext } from "../../context/channels";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useToaster } from "../../context/toaster";
import { AuthContext } from "../../context/auth";

const Account = () => {
  const { profile } = useContext(ProfileContext);
  const { user } = useContext(AuthContext);
  const [userVideos, setUserVideos] = useState();
  const [adminChannels, setAdminChannels] = useState();
  const [isLoadingAdminChannels, setIsLoadingAdminChannels] = useState(true);
  const [isLoadingMyCampaigns, setIsLoadingAdminMyCampaigns] = useState(true);
  const { userChannels, isLoadingUserChannels, getUsersChannels, channels } =
    useContext(ChannelContext);
  const [tag, setTag] = useState({
    open: false,
    value: "",
    loading: false,
  });
  const [cat, setCat] = useState({
    open: false,
    value: "",
    loading: false,
  });
  const [transfer, setTransfer] = useState({
    open: false,
    value: {
      channelId: "",
      userId: "",
    },
    loading: false,
  });
  const { addMessage } = useToaster();
  const [myCampaigns, setMyCampains] = useState();
  const [users, setUsers] = useState([]);
  const [channelSearch, setChannelSearch] = useState("");
  const [userSearch, setUserSearch] = useState("");
  const [showChannelDropdown, setShowChannelDropdown] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const handleChannelSearch = async (value) => {
    setChannelSearch(value);
    if (!value.trim()) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    try {
      const res = await channelFetcher.searchChannels(value);
      setSearchResults(res.results);
    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setIsSearching(false);
    }
  };

  const filteredChannels = channels?.results?.filter(
    (item) =>
      item.name.toLowerCase().includes(channelSearch.toLowerCase()) ||
      item.id.toString().includes(channelSearch)
  );

  const filteredUsers = users?.filter((item) => {
    const search = userSearch.toLowerCase();

    return (
      (item.username && item.username.toLowerCase().includes(search)) ||
      (item.name && item.name.toLowerCase().includes(search)) ||
      (item.profile?.first_name &&
        item.profile.first_name.toLowerCase().includes(search)) ||
      (item.profile?.last_name &&
        item.profile.last_name.toLowerCase().includes(search)) ||
      item.id.toString().includes(search)
    );
  });

  const getUsersVideos = async () => {
    if (profile.user) {
      try {
        const videos = await videoFetcher.getUserVideos(profile.user);
        setUserVideos(videos);
      } catch (error) {
        console.error("Error fetching user videos:", error);
      }
    }
  };

  const getAdminChannels = async () => {
    if (profile.user) {
      setIsLoadingAdminChannels(true);
      try {
        const channels = await channelFetcher.adminsChannels(profile.user);
        setAdminChannels(channels);
      } catch (error) {
        console.error("Error fetching admin channels:", error);
      } finally {
        setIsLoadingAdminChannels(false);
      }
    }
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleTagClick = async () => {
    setTag({ ...tag, loading: true });
    try {
      const res = await tagFetcher.post({ name: tag.value, confirm: true });

      if (res.id) {
        showToast("success", "تگ با موفقیت ساخته شد.");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTag({ ...tag, loading: false });
    }
  };

  const handleCatClick = async () => {
    setCat({ ...cat, loading: true });
    try {
      const res = await categoryFetcher.post({
        name: cat.value,
        type: "category",
      });

      if (res.id) {
        showToast("success", "دسته بندی با موفقیت ساخته شد.");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCat({ ...tag, loading: false });
    }
  };

  const handleTransferClick = async () => {
    setTransfer({ ...transfer, loading: true });
    try {
      const res = await channelFetcher.transferChannelOwnership({
        new_owner: transfer.value.userId,
        channel: transfer.value.channelId,
      });

      if (res) {
        showToast("success", ".مالکیت با موفقیت منتقل شد");
      }
    } catch (error) {
      console.error(error);
      showToast("error", error?.response?.data?.detail);
    } finally {
      setTransfer({ ...transfer, loading: false });
    }
  };

  const getCampaigns = async () => {
    setIsLoadingAdminMyCampaigns(true);
    try {
      const res = await (user.role === "is_superuser" ||
      user.role === "is_supervisor"
        ? campaignFetcher.getActiveCampaigns()
        : campaignFetcher.getUsersCampaigns(user.user_id));

      if (res?.count) {
        setMyCampains(res?.results);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingAdminMyCampaigns(false);
    }
  };

  const getUsersData = async () => {
    try {
      const res = await accountUpgradeFetcher.getUsers();

      if (res.count > 0) setUsers(res.results);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getUsersChannels();
    getUsersVideos();
    getAdminChannels();
    getCampaigns();
    getUsersData();
  }, [profile.user]);

  return (
    <>
      <ContentWrapper>
        <Container
          fluid
          className="pb-0"
          style={{
            textAlign: "-webkit-center",
            minHeight: "calc(100vh - 123px)",
          }}
        >
          <Row
            style={{
              paddingLeft: "45px",
              paddingRight: "45px",
              paddingTop: "30px",
            }}
          >
            <InfoCards
              userChannels={userChannels?.results}
              userVideos={userVideos?.results}
              ownerId={profile.user}
            />
          </Row>

          <hr style={{ marginTop: "25px" }} />
          <div
            style={{
              paddingTop: "20px",
              paddingLeft: "20px",
              paddingRight: "20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {(user.role === "is_superuser" ||
              (user.role === "is_supervisor" &&
                user.permissions.includes("channel_ownership_transfer"))) && (
              <>
                <span
                  className="nav-link LinkStyle"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                    width: "fit-content",
                  }}
                  onClick={async () => {
                    setTransfer({ ...transfer, open: !transfer.open });
                  }}
                >
                  <FontAwesomeIcon
                    icon={faPlusCircle}
                    color="green"
                    fixedWidth
                  />{" "}
                  <span style={{ color: "green" }}>انتقال مالکیت یک کانال</span>
                </span>
                {transfer.open && (
                  <>
                    {/* Channel Select */}
                    <Form.Group
                      as={Col}
                      style={{
                        width: "300px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        marginBottom: "10px",
                        position: "relative",
                      }}
                    >
                      <Form.Label>کانال</Form.Label>
                      <div
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          position: "relative",
                          background: "#fff",
                        }}
                      >
                        <div
                          onClick={() => {
                            setShowChannelDropdown(!showChannelDropdown);
                            setShowUserDropdown(false);
                          }}
                          style={{
                            padding: "6px 8px",
                            cursor: "pointer",
                            fontSize: "13px",
                          }}
                        >
                          {transfer.value.channelId
                            ? filteredChannels.find(
                                (c) => c.id == transfer.value.channelId
                              )?.name + ` (ID: ${transfer.value.channelId})`
                            : "یک کانال انتخاب کنید"}
                        </div>

                        {showChannelDropdown && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "100%",
                              background: "#fff",
                              border: "1px solid #ddd",
                              borderRadius: "0 0 4px 4px",
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                            }}
                          >
                            {/* Search Box */}
                            <input
                              type="text"
                              placeholder="جستجو بر اساس نام"
                              value={channelSearch}
                              onChange={(e) =>
                                handleChannelSearch(e.target.value)
                              }
                              style={{
                                width: "100%",
                                padding: "6px 8px",
                                border: "none",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            />

                            {/* Options */}
                            {isSearching ? (
                              <div style={{ padding: "6px 8px" }}>
                                در حال جستجو...
                              </div>
                            ) : searchResults.length > 0 ? (
                              searchResults.map((item) => (
                                <div
                                  key={item.id}
                                  onClick={() => {
                                    setTransfer({
                                      ...transfer,
                                      value: {
                                        ...transfer.value,
                                        channelId: item.id,
                                      },
                                    });
                                    setShowChannelDropdown(false);
                                  }}
                                  style={{
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    background:
                                      transfer.value.channelId == item.id
                                        ? "#f0f0f0"
                                        : "transparent",
                                    borderBottom: "1px dashed gray",
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // keeps input from blurring
                                >
                                  {item.name}{" "}
                                  <span style={{ color: "green" }}>
                                    (ID: {item.id})
                                  </span>
                                </div>
                              ))
                            ) : channels.results.length > 0 ? (
                              channels.results.map((item) => (
                                <div
                                  key={item.id}
                                  onClick={() => {
                                    setTransfer({
                                      ...transfer,
                                      value: {
                                        ...transfer.value,
                                        channelId: item.id,
                                      },
                                    });
                                    setShowChannelDropdown(false);
                                  }}
                                  style={{
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    background:
                                      transfer.value.channelId == item.id
                                        ? "#f0f0f0"
                                        : "transparent",
                                    borderBottom: "1px dashed gray",
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // keeps input from blurring
                                >
                                  {item.name}{" "}
                                  <span style={{ color: "green" }}>
                                    (ID: {item.id})
                                  </span>
                                </div>
                              ))
                            ) : (
                              <div
                                style={{
                                  padding: "6px 8px",
                                  fontSize: "13px",
                                  color: "#888",
                                }}
                              >
                                نام کانال مورد نظر خود را سرچ کنید
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      style={{
                        width: "300px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        marginBottom: "10px",
                        position: "relative",
                      }}
                    >
                      <Form.Label>کاربر</Form.Label>
                      <div
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          position: "relative",
                          background: "#fff",
                        }}
                      >
                        <div
                          onClick={() => {
                            setShowUserDropdown(!showUserDropdown);
                            setShowChannelDropdown(false);
                          }}
                          style={{
                            padding: "6px 8px",
                            cursor: "pointer",
                            fontSize: "13px",
                          }}
                        >
                          {transfer.value.userId
                            ? filteredUsers.find(
                                (u) => u.id == transfer.value.userId
                              )?.username ||
                              filteredUsers.find(
                                (u) => u.id == transfer.value.userId
                              )?.profile?.first_name ||
                              filteredUsers.find(
                                (u) => u.id == transfer.value.userId
                              )?.profile?.last_name ||
                              `User ID: ${transfer.value.userId}`
                            : "یک کاربر انتخاب کنید"}
                        </div>

                        {showUserDropdown && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "100%",
                              background: "#fff",
                              border: "1px solid #ddd",
                              borderRadius: "0 0 4px 4px",
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                            }}
                          >
                            <input
                              type="text"
                              placeholder="جستجو بر اساس نام یا ID"
                              value={userSearch}
                              onChange={(e) => setUserSearch(e.target.value)}
                              style={{
                                width: "100%",
                                padding: "6px 8px",
                                border: "none",
                                borderBottom: "1px solid #eee",
                                fontSize: "13px",
                              }}
                            />
                            {filteredUsers.length > 0 ? (
                              filteredUsers.map((item) => (
                                <div
                                  key={item.id}
                                  onClick={() => {
                                    setTransfer({
                                      ...transfer,
                                      value: {
                                        ...transfer.value,
                                        userId: item.id,
                                      },
                                    });
                                    setShowUserDropdown(false);
                                  }}
                                  style={{
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    background:
                                      transfer.value.userId == item.id
                                        ? "#f0f0f0"
                                        : "transparent",
                                    borderBottom: "1px dashed gray",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  <span>{item.username}</span>
                                  <span>
                                    {(!/[\d]/.test(item.profile.first_name) &&
                                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                      item.profile.first_name
                                    )
                                      ? item.profile.first_name
                                      : "") +
                                      " " +
                                      (!/[\d]/.test(item.profile.last_name) &&
                                      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                        item.profile.last_name
                                      )
                                        ? item.profile.last_name
                                        : "")}
                                  </span>

                                  <span style={{ color: "green" }}>
                                    (ID: {item.id})
                                  </span>
                                </div>
                              ))
                            ) : (
                              <div
                                style={{
                                  padding: "6px 8px",
                                  fontSize: "13px",
                                  color: "#888",
                                }}
                              >
                                نتیجه‌ای یافت نشد
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Form.Group>

                    <Button
                      variant="success"
                      type="button"
                      style={{
                        width: "fit-content",
                        fontSize: "12px",
                        padding: "2px 8px",
                        borderRadius: "2px",
                      }}
                      onClick={handleTransferClick}
                    >
                      {transfer.loading ? "در حال ارسال..." : "ذخیره"}
                    </Button>
                  </>
                )}
              </>
            )}
            <Link
              to="/create-channel"
              className="nav-link"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
                width: "fit-content",
              }}
            >
              <FontAwesomeIcon icon={faPlusCircle} fixedWidth />
              <span>کانال جدید</span>
            </Link>
            {(user.role === "is_superuser" || user.role === "is_supervisor") &&
              user?.permissions?.includes("campaign") && (
                <Link
                  to="/create-campaign"
                  className="nav-link"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                    width: "fit-content",
                  }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} fixedWidth />
                  <span>پویش جدید</span>
                </Link>
              )}
            {(user.role === "is_superuser" ||
              user.role === "is_supervisor") && (
              <>
                <span
                  className="nav-link LinkStyle"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                    width: "fit-content",
                  }}
                  onClick={() => setTag({ ...tag, open: !tag.open })}
                >
                  <FontAwesomeIcon icon={faPlusCircle} fixedWidth />{" "}
                  <span>تگ جدید</span>
                </span>
                {tag.open && (
                  <>
                    <Form.Group
                      as={Col}
                      controlId="name"
                      style={{
                        width: "300px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        marginBottom: "5px",
                      }}
                    >
                      <Form.Label style={{ marginBottom: "3px" }}>
                        نام تگ
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        value={tag.value}
                        onChange={(e) =>
                          setTag({ ...tag, value: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Button
                      variant="success mr-3"
                      type="button"
                      style={{
                        width: "fit-content",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        fontSize: "12px",
                        padding: "2px",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        borderRadius: "2px",
                      }}
                      onClick={handleTagClick}
                    >
                      {tag.loading ? "در حال ارسال..." : "ذخیره"}
                    </Button>
                  </>
                )}
                <span
                  className="nav-link LinkStyle"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                    width: "fit-content",
                  }}
                  onClick={() => setCat({ ...cat, open: !cat.open })}
                >
                  <FontAwesomeIcon icon={faPlusCircle} fixedWidth />{" "}
                  <span>دسته بندی جدید</span>
                </span>
                {cat.open && (
                  <>
                    <Form.Group
                      as={Col}
                      controlId="name"
                      style={{
                        width: "300px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                      }}
                    >
                      <Form.Label>نام دسته بندی</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        value={cat.value}
                        onChange={(e) =>
                          setCat({ ...cat, value: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Button
                      variant="success mr-3"
                      type="button"
                      style={{
                        width: "fit-content",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        fontSize: "12px",
                        padding: "2px",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        borderRadius: "2px",
                      }}
                      onClick={handleCatClick}
                    >
                      {cat.loading ? "در حال ارسال..." : "ذخیره"}
                    </Button>
                  </>
                )}
              </>
            )}
          </div>

          <hr id="myChannels" style={{ marginTop: "35px" }} />
          <div>
            {isLoadingUserChannels ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: "100%", height: "200px" }}
              >
                <Spinner animation="border" role="status" />
              </div>
            ) : (
              <MyChannels
                mine={true}
                userChannels={userChannels?.results}
                header="کانال های من (مالک)"
                campaign={false}
              />
            )}
          </div>

          <hr />
          <div>
            {isLoadingAdminChannels ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: "100%", height: "200px" }}
              >
                <Spinner animation="border" role="status" />
              </div>
            ) : (
              <AdminChannels
                mine={true}
                admin={true}
                userChannels={adminChannels?.results}
                header="کانال های من (ادمین)"
              />
            )}
          </div>

          {(user?.role === "is_superuser" || user?.role === "is_supervisor") &&
            user?.permissions?.includes("campaign") && (
              <>
                <hr id="myCampaigns" />
                <div>
                  {isLoadingMyCampaigns ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ width: "100%", height: "200px" }}
                    >
                      <Spinner animation="border" role="status" />
                    </div>
                  ) : (
                    <MyChannels
                      mine={true}
                      userChannels={myCampaigns}
                      header="كمپین ها"
                      campaign={true}
                    />
                  )}
                </div>
              </>
            )}
        </Container>
        <ThinFooter />
      </ContentWrapper>
    </>
  );
};

export default Account;
